export type Activity = {
  number: string;
  title: string;
  description: string;
};

export const organization = {
  nameJa: "青少年科学者社会接続推進協会",
  nameEn: "Association for the Integration of Young Scientists into Society",
};

export type Member = {
  name: string;
  title: string;
  photo?: string;
  alt?: string;
};

export const activities: Activity[] = [
  {
    number: "01",
    title: "同じ興味を持つ仲間と繋がる",
    description:
      "AI Competition Leagueの上位入賞者と交流会を開催します。また、仲間同士で競い合えるデータサイエンスコンペの年間リーグも運営します。",
  },
  {
    number: "02",
    title: "技術力の高い企業と繋がる",
    description:
      "高い専門性を持つ企業のエンジニアによる、学生向けのオンライン技術講演を実施します。企業訪問や懇親会のマッチング、早期インターン・バイト情報の提供を通じて、技術力の高い企業とつながる機会をつくります。",
  },
];

export const coreMembers: Member[] = [
  {
    name: "小山昊想 (高1)",
    title:
      "アジア太平洋人工知能オリンピック銅メダル\nAtCoder Heuristicレート 橙",
    photo: "/assets/images/member-koyama.png",
    alt: "小山昊想",
  },
  {
    name: "霜崎洸我 (高2)",
    title:
      "国際原子力科学オリンピック金メダル\n日本言語学オリンピック金賞\n物理チャレンジ本選出場",
    photo: "/assets/images/member-shimozaki.png",
    alt: "霜崎洸我",
  },
];

export const otherMembers: Member[] = [
  {
    name: "濱口 琉良 (高2)",
    title: "日本情報オリンピック本選出場\nパソコン甲子園モバイル部門出場",
  },
  {
    name: "鈴置 祥大 (高1)",
    title: "日本ロボット学会U18Forum優秀賞\nロボカップジュニアジャパン出場",
  },
  {
    name: "小林 晴宗 (高2)",
    title: "Kaggle Expert（銀メダル2つ獲得）",
  },
];
